import React from 'react';
import './Community.css';

const Community = () => {
  const socials = [
    {
      name: 'Twitter / X',
      icon: '𝕏',
      description: 'Follow for updates & memes',
      link: 'https://x.com/goldonerc',
      isImage: false
    },
    {
      name: 'Telegram',
      icon: 'https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg',
      description: 'Join the community chat',
      link: 'https://t.me/goldonerc',
      isImage: true
    },
    {
      name: 'DexTools',
      icon: 'https://cdn.worldvectorlogo.com/logos/dextools.svg',
      description: 'Track the chart',
      link: 'https://dextools.io',
      isImage: true
    }
  ];

  return (
    <section className="community" id="community">
      <div className="container">
        <h2 className="section-title">
          <span className="gold-text">Join the Revolution</span>
        </h2>

        <p className="community-subtitle">
          Be part of the fastest-growing gold community in crypto. Diamond hands only. 💎🙌
        </p>

        <div className="socials-grid">
          {socials.map((social, index) => (
            <a 
              href={social.link} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-card"
              key={index}
            >
              {social.isImage ? (
                <img src={social.icon} alt={social.name} className="social-icon-img" />
              ) : (
                <span className="social-icon">{social.icon}</span>
              )}
              <h3 className="social-name">{social.name}</h3>
              <p className="social-description">{social.description}</p>
            </a>
          ))}
        </div>

        <div className="community-cta">
          <div className="cta-content">
            <h3>Ready to Join the Golden Era?</h3>
            <p>Don't miss out on the next 100x. Gold has been money for 5,000 years. <span className="gold-text">$GOLD</span> is just getting started.</p>
            <div className="cta-buttons">
              <button className="btn-primary">Buy $GOLD Now</button>
              <a href="https://t.me/goldonerc" target="_blank" rel="noopener noreferrer" className="btn-secondary btn-telegram">
                Join Telegram
                <img src="https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg" alt="Telegram" className="telegram-icon" />
              </a>
            </div>
          </div>
          <div className="cta-visual">
            <img src="https://png.pngtree.com/png-vector/20240103/ourmid/pngtree-gold-prices-increase-png-image_11259981.png" alt="Gold Prices Increase" className="gold-increase-img" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Community;
